export const NEW_ITEM = "NEW_ITEM"
export const TRUE_WISH = "TRUE_WISH"
export const FEED_CARD = "feedCard" as const
export const PRO_BANNER = "proBanner" as const
export const POPULAR_ITEMS = "popularItems" as const
export const QUICK_CREATE_CARD = "quickCreateCard" as const

type BaseLayoutItem = {
  order: number;
}

type FeedCardLayoutItem = BaseLayoutItem & {
  type: typeof FEED_CARD;
  start: number;
  end: number;
}

type OtherLayoutItem = BaseLayoutItem & {
  type: typeof PRO_BANNER | typeof POPULAR_ITEMS | typeof QUICK_CREATE_CARD;
}

type LayoutItem = FeedCardLayoutItem | OtherLayoutItem;

export const FEED_LAYOUT_RULES = [
  {
    when: (feeds: WishamFeed[]) => feeds.length === 0,
    layout: [
      { type: QUICK_CREATE_CARD, order: 1 },
      { type: POPULAR_ITEMS, order: 2 },
      { type: PRO_BANNER, order: 3 }
    ] as LayoutItem[]
  },
  {
    when: (feeds: WishamFeed[]) => feeds.length > 0,
    layout: [
      { type: QUICK_CREATE_CARD, order: 1 },
      { type: FEED_CARD, order: 2, start: 0, end: 2 },
      { type: PRO_BANNER, order: 3 },
      { type: FEED_CARD, order: 4, start: 2, end: 4 },
      { type: POPULAR_ITEMS, order: 5 }
    ] as LayoutItem[]
  }
]

type normalizeLayoutOptions = {
  removeTypes?: string[];
}

export function normalizeLayout(items: LayoutItem[], options: normalizeLayoutOptions): LayoutItem[] {
  const { removeTypes = [] } = options

  const removedOrders: number[] = []

  const filtered = items.filter((item) => {
    if (removeTypes.includes(item.type)) {
      removedOrders.push(item.order)
      return false
    }
    return true
  })

  if (removedOrders.length === 0) return filtered.sort((a, b) => a.order - b.order)

  const normalized = filtered.map((layout) => {
    if (layout.type === FEED_CARD || layout.type === QUICK_CREATE_CARD) return layout
    const newOrder = removedOrders.shift()
    if (!newOrder) return layout
    return { ...layout, order: newOrder }
  })

  return normalized.sort((a, b) => a.order - b.order)
}
